// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { auth, db } from "../firebase/firebaseConfig";
// import { doc, updateDoc } from "firebase/firestore";
// import { load } from "@cashfreepayments/cashfree-js";
// import axios from "axios";
// import { v4 as uuidv4 } from "uuid";
// import { ClipLoader } from "react-spinners";

// const SubscriptionPage = () => {
//     const [loading, setLoading] = useState(false);
//     const [cashfree, setCashfree] = useState(null);
//     const navigate = useNavigate();

//     const subscriptionPlans = [
//         {
//             id: "basic_60",
//             name: "60 Days Access",
//             price: 1,
//             duration: 60,
//             description: "Access all premium content for 60 days"
//         }
//     ];

//     useEffect(() => {
//         const initializeCashfree = async () => {
//             try {
//                 const cashfreeInstance = await load({ mode: "production" });
//                 setCashfree(cashfreeInstance);
//             } catch (error) {
//                 console.error("Error initializing Cashfree:", error);
//                 alert("Failed to initialize payment gateway");
//             }
//         };
//         initializeCashfree();
//     }, []);

//     const handleSubscribe = async (plan) => {
//         if (!auth.currentUser) {
//             alert("Please login to purchase subscription");
//             navigate('/login');
//             return;
//         }

//         setLoading(true);

//         try {
//             const orderId = `sub_${uuidv4()}`;
//             const user = auth.currentUser;

//             // Save subscription order to Firestore
//             const userDocRef = doc(db, "users", user.uid);

//             const orderData = {
//                 orderId,
//                 type: "subscription",
//                 plan: plan,
//                 amount: plan.price,
//                 status: "pending",
//                 createdAt: new Date(),
//                 userId: user.uid
//             };

//             await updateDoc(userDocRef, {
//                 [`subscriptionOrders.${orderId}`]: orderData
//             });

//             // Create payment session (using your existing backend)
//             const response = await axios.post('https://cashfree-backend-1k3q.onrender.com/create-payment-session', {
//                 orderId,
//                 orderAmount: plan.price,
//                 customerName: user.displayName || "User",
//                 customerEmail: user.email,
//                 customerPhone: "9999999999",
//             });

//             if (response.data?.payment_session_id) {
//                 // Process payment
//                 const checkoutOptions = {
//                     paymentSessionId: response.data.payment_session_id,
//                     redirectTarget: "_modal",
//                 };

//                 cashfree.checkout(checkoutOptions).then(async (result) => {
//                     if (result.paymentDetails) {
//                         // Payment successful - activate subscription
//                         const expiryDate = new Date();
//                         expiryDate.setDate(expiryDate.getDate() + plan.duration);

//                         await updateDoc(userDocRef, {
//                             subscription: {
//                                 planId: plan.id,
//                                 purchasedDate: new Date(),
//                                 expiryDate: expiryDate,
//                                 status: "active"
//                             },
//                             [`subscriptionOrders.${orderId}.status`]: "completed"
//                         });

//                         alert("Subscription activated successfully! 🎉");
//                         navigate('/blogs');
//                     }
//                 });
//             }
//         } catch (error) {
//             console.error("Subscription error:", error);
//             alert("Failed to process subscription");
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
//             <h1 style={{ textAlign: "center", marginBottom: "30px" }}>
//                 Subscribe to Premium Content
//             </h1>

//             <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
//                 {subscriptionPlans.map((plan) => (
//                     <div key={plan.id} style={{
//                         border: "2px solid #28a745",
//                         borderRadius: "10px",
//                         padding: "20px",
//                         width: "250px",
//                         textAlign: "center"
//                     }}>
//                         <h3>{plan.name}</h3>
//                         <h2>₹{plan.price}</h2>
//                         <p>{plan.description}</p>

//                         <button
//                             onClick={() => handleSubscribe(plan)}
//                             disabled={loading}
//                             style={{
//                                 width: "100%",
//                                 padding: "12px",
//                                 backgroundColor: loading ? "#ccc" : "#28a745",
//                                 color: "white",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: loading ? "not-allowed" : "pointer"
//                             }}
//                         >
//                             {loading ? <ClipLoader size={20} color="#ffffff" /> : "Subscribe Now"}
//                         </button>
//                     </div>
//                 ))}
//             </div>

//             <div style={{ marginTop: "30px", textAlign: "center" }}>
//                 <button
//                     onClick={() => navigate(-1)}
//                     style={{
//                         padding: "10px 20px",
//                         backgroundColor: "#6c757d",
//                         color: "white",
//                         border: "none",
//                         borderRadius: "5px",
//                         cursor: "pointer"
//                     }}
//                 >
//                     ← Go Back
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default SubscriptionPage;

import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth, db } from "../firebase/firebaseConfig";
import { doc, updateDoc, collection, query, where, onSnapshot, addDoc, orderBy } from "firebase/firestore";
import { load } from "@cashfreepayments/cashfree-js";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { ClipLoader } from "react-spinners";
import { Helmet } from 'react-helmet';

const SubscriptionPage = () => {
    const [loading, setLoading] = useState(false);
    const [cashfree, setCashfree] = useState(null);
    const [referralCode, setReferralCode] = useState(''); // Only for friend's code input
    const [userData, setUserData] = useState(null);
    const [userLoading, setUserLoading] = useState(true);
    const [tempUpiId, setTempUpiId] = useState(''); // Temporary state for UPI input
    const [tempPhoneNumber, setTempPhoneNumber] = useState(''); // NEW: Temporary state for phone number
    const [showUpiForm, setShowUpiForm] = useState(false);
    const [showPhoneForm, setShowPhoneForm] = useState(false); // NEW: Show phone form state
    const [userReferrals, setUserReferrals] = useState([]); // Referrals where user is the referrer
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const subscriptionPlans = [
        {
            id: "basic_30",
            name: "30 Days",
            price: 50,
            duration: 30,
            description: "Access all premium content for 30 days"
        }
    ];

    useEffect(() => {
        const initializeCashfree = async () => {
            try {
                const cashfreeInstance = await load({ mode: "production" });
                setCashfree(cashfreeInstance);
            } catch (error) {
                console.error("Error initializing Cashfree:", error);
            }
        };

        initializeCashfree();

        // Auto-fill referral code from URL
        const refCode = searchParams.get('ref');
        if (refCode) {
            setReferralCode(refCode);
            localStorage.setItem("referralCodeUsed", refCode);
        }
    }, [searchParams]);

    // FIX 1: Proper auth state listener for user data
    useEffect(() => {
        const unsubscribeAuth = auth.onAuthStateChanged((user) => {
            if (user) {
                // console.log("User authenticated:", user.uid);

                // FIX 2: Real-time listener for user data
                const userDocRef = doc(db, "users", user.uid);
                const unsubscribeFirestore = onSnapshot(userDocRef, (docSnap) => {
                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        // console.log("User data loaded from Firestore:", data);
                        setUserData(data);

                        // Initialize tempUpiId only when data loads
                        if (data.upiId && !tempUpiId) {
                            setTempUpiId(data.upiId);
                        }

                        // Initialize tempPhoneNumber only when data loads
                        if (data.phoneNumber && !tempPhoneNumber) {
                            setTempPhoneNumber(data.phoneNumber);
                        }

                        // Load user's referrals when user data is available
                        if (data.referralCode) {
                            loadUserReferrals(data.referralCode);
                        }
                    } else {
                        console.log("User document doesn't exist yet");
                        setUserData(null);
                    }
                    setUserLoading(false);
                }, (error) => {
                    console.error("Error listening to user data:", error);
                    setUserLoading(false);
                });

                return unsubscribeFirestore;
            } else {
                console.log("No user authenticated");
                setUserData(null);
                setUserLoading(false);
            }
        });

        return () => unsubscribeAuth();
    }, [tempUpiId, tempPhoneNumber]);

    // 1. Add this to your cart page (or app initialization)
    useEffect(() => {
        const warmUpServer = async () => {
            try {
                await axios.get('https://cashfree-backend-1k3q.onrender.com/warmup', {
                    timeout: 3000 // Don't wait too long
                });
            } catch (error) {
                console.log('Server warming in background...');
            }
        };
        warmUpServer();
    }, []);

    // ✅ UPDATED: Load referrals with error handling for index
    const loadUserReferrals = (userReferralCode) => {
        if (!userReferralCode) return;

        try {
            const referralsRef = collection(db, "referrals");

            // Try the query with orderBy first
            const q = query(
                referralsRef,
                where("referrerCode", "==", userReferralCode),
                orderBy("createdAt", "desc")
            );

            const unsubscribe = onSnapshot(q,
                (snapshot) => {
                    const referrals = snapshot.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));
                    // console.log("Loaded user referrals:", referrals);
                    setUserReferrals(referrals);
                },
                (error) => {
                    console.error("Error in referrals snapshot:", error);

                    // If index error, use fallback query without orderBy
                    if (error.code === 'failed-precondition') {
                        console.log("Index not ready, using fallback query...");

                        const fallbackQ = query(
                            referralsRef,
                            where("referrerCode", "==", userReferralCode)
                        );

                        onSnapshot(fallbackQ, (fallbackSnapshot) => {
                            const fallbackReferrals = fallbackSnapshot.docs.map(doc => ({
                                id: doc.id,
                                ...doc.data()
                            }));

                            // Manual sorting on client side
                            fallbackReferrals.sort((a, b) => {
                                const dateA = a.createdAt?.toDate?.() || a.createdAt;
                                const dateB = b.createdAt?.toDate?.() || b.createdAt;
                                return new Date(dateB) - new Date(dateA);
                            });

                            // console.log("Loaded referrals (fallback):", fallbackReferrals);
                            setUserReferrals(fallbackReferrals);
                        });
                    }
                }
            );

            return unsubscribe;
        } catch (error) {
            console.error("Error loading referrals:", error);
        }
    };

    // Generate referral code for user
    const generateReferralCode = async () => {
        const user = auth.currentUser;
        if (!user) {
            alert("Please login to generate referral code");
            return;
        }

        try {
            const userDocRef = doc(db, "users", user.uid);
            const userName = user.displayName || user.email.split('@')[0] || "USER";
            const base = userName.toUpperCase().replace(/\s/g, '').replace(/[^A-Z0-9]/g, '').slice(0, 6);
            const random = Math.random().toString(36).substring(2, 5).toUpperCase();
            const newReferralCode = (base + random).slice(0, 9);

            const updateData = {
                referralCode: newReferralCode
            };

            if (!userData?.name) {
                updateData.name = user.displayName || "User";
            }
            if (!userData?.email) {
                updateData.email = user.email;
            }

            await updateDoc(userDocRef, updateData, { merge: true });

            // console.log("Referral code generated:", newReferralCode);
            alert("Referral code generated successfully!");
        } catch (error) {
            // console.error("Error generating referral code:", error);
            alert("Failed to generate referral code");
        }
    };

    // ✅ NEW: Store referral code before payment
    const handleReferralCodeSubmit = async () => {
        if (!referralCode) {
            alert("Enter a referral code first");
            return;
        }
        localStorage.setItem("referralCodeUsed", referralCode);
        alert("Referral code applied successfully ✅");
    };

    // Save UPI ID
    const saveUpiId = async () => {
        if (!tempUpiId) {
            alert("Please enter UPI ID");
            return;
        }

        const user = auth.currentUser;
        if (!user) {
            alert("Please login first");
            return;
        }

        try {
            const userDocRef = doc(db, "users", user.uid);
            await updateDoc(userDocRef, {
                upiId: tempUpiId
            }, { merge: true });

            setShowUpiForm(false);
            alert("UPI ID saved successfully!");
        } catch (error) {
            // console.error("Error saving UPI ID:", error);
            alert("Failed to save UPI ID");
        }
    };

    // NEW: Save Phone Number function
    const savePhoneNumber = async () => {
        if (!tempPhoneNumber) {
            alert("Please enter phone number");
            return;
        }

        // Basic phone number validation
        const phoneRegex = /^[6-9]\d{9}$/; // Indian phone number validation
        if (!phoneRegex.test(tempPhoneNumber.replace(/\D/g, ''))) {
            alert("Please enter a valid 10-digit Indian phone number");
            return;
        }

        const user = auth.currentUser;
        if (!user) {
            alert("Please login first");
            return;
        }

        try {
            const userDocRef = doc(db, "users", user.uid);
            await updateDoc(userDocRef, {
                phoneNumber: tempPhoneNumber
            }, { merge: true });

            setShowPhoneForm(false);
            alert("Phone number saved successfully!");
        } catch (error) {
            console.error("Error saving phone number:", error);
            alert("Failed to save phone number");
        }
    };

    // ✅ UPDATED: Permission-safe referral handling with status update
    const handleReferral = async (referralCode) => {
        const user = auth.currentUser;
        if (!user) {
            console.log("No user authenticated for referral");
            return;
        }

        if (!referralCode) {
            console.log("No referral code provided");
            return;
        }

        // console.log("Processing referral for code:", referralCode, "from user:", user.email);

        try {
            // ✅ STEP 1: Create a central referral record (no permission issues)
            const referralDocRef = await addDoc(collection(db, "referrals"), {
                referrerCode: referralCode,
                friendId: user.uid,
                friendName: user.displayName || "User",
                friendEmail: user.email,
                commission: 20, // Fixed ₹20 commission
                amount: subscriptionPlans[0].price,
                status: "completed", // ✅ CHANGED: Set as completed immediately since payment is done
                withdrawRequested: false,
                withdrawPaid: false,
                createdAt: new Date()
            });

            // ✅ STEP 2: Track in friend's own document (allowed - writing to own doc)
            const userDocRef = doc(db, "users", user.uid);
            await updateDoc(userDocRef, {
                referralUsed: referralCode,
                usedReferralAt: new Date()
            }, { merge: true });

            console.log("Referral recorded successfully ✅ with ID:", referralDocRef.id);
            alert("🎉 Referral recorded! Your friend will receive ₹20 commission!");

            // Clear the used referral code
            localStorage.removeItem("referralCodeUsed");
            setReferralCode('');

        } catch (error) {
            console.error("Referral error:", error);
            alert("Failed to process referral: " + error.message);
        }
    };

    const handleSubscribe = async (plan) => {
        const user = auth.currentUser;
        if (!user) {
            alert("Please login to purchase subscription");
            navigate('/login');
            return;
        }

        // NEW: Check if phone number is set
        if (!userData?.phoneNumber) {
            alert("Please set your phone number first for transaction verification and support");
            setShowPhoneForm(true);
            return;
        }

        setLoading(true);

        try {
            const orderId = `sub_${uuidv4()}`;

            // Save subscription order
            const userDocRef = doc(db, "users", user.uid);
            const orderData = {
                orderId,
                type: "subscription",
                plan: plan,
                amount: plan.price,
                status: "pending",
                createdAt: new Date(),
                userId: user.uid,
                referralCode: referralCode || null,
                customerPhone: userData.phoneNumber // NEW: Store phone in order data
            };

            await updateDoc(userDocRef, {
                [`subscriptionOrders.${orderId}`]: orderData
            }, { merge: true });

            // UPDATED: Process payment with actual phone number
            const response = await axios.post('https://cashfree-backend-1k3q.onrender.com/create-payment-session', {
                orderId,
                orderAmount: plan.price,
                customerName: user.displayName || "User",
                customerEmail: user.email,
                customerPhone: userData.phoneNumber, // CHANGED: Use actual phone number instead of default
            });

            if (response.data?.payment_session_id) {
                const checkoutOptions = {
                    paymentSessionId: response.data.payment_session_id,
                    redirectTarget: "_modal",
                };

                cashfree.checkout(checkoutOptions).then(async (result) => {
                    if (result.paymentDetails) {
                        // console.log("Payment successful, activating subscription...");

                        // Payment successful
                        const expiryDate = new Date();
                        expiryDate.setDate(expiryDate.getDate() + plan.duration);

                        await updateDoc(userDocRef, {
                            subscription: {
                                planId: plan.id,
                                purchasedDate: new Date(),
                                expiryDate: expiryDate,
                                status: "active"
                            },
                            [`subscriptionOrders.${orderId}.status`]: "completed"
                        }, { merge: true });

                        // ✅ FIXED: Handle referral AFTER payment success
                        const usedReferralCode = localStorage.getItem("referralCodeUsed") || referralCode;
                        if (usedReferralCode) {
                            // console.log("Processing referral after payment for code:", usedReferralCode);
                            try {
                                await handleReferral(usedReferralCode);
                            } catch (referralError) {
                                console.error("Referral processing error:", referralError);
                                // Don't block navigation if referral fails
                            }
                        }

                        alert("Subscription activated successfully! 🎉");
                        navigate('/blogsCategory');
                    }
                }).catch((error) => {
                    console.error("Payment error:", error);
                    alert("Payment failed");
                    setLoading(false);
                });
            }
        } catch (error) {
            console.error("Subscription error:", error);
            alert("Failed to process subscription");
            setLoading(false);
        }
    };

    const copyReferralLink = () => {
        if (!userData?.referralCode) {
            alert("Please generate a referral code first");
            return;
        }

        const link = `${window.location.origin}/subscription?ref=${userData.referralCode}`;
        navigator.clipboard.writeText(link);
        alert("Referral link copied! Share it with your friends.");
    };

    // ✅ UPDATED: Withdrawal request for the new structure
    const requestWithdraw = async (referralId) => {
        const user = auth.currentUser;
        if (!user) {
            alert("Please login first");
            return;
        }

        if (!userData?.upiId) {
            alert("Please set your UPI ID first to receive payments");
            return;
        }

        try {
            const referralDocRef = doc(db, "referrals", referralId);
            await updateDoc(referralDocRef, {
                withdrawRequested: true,
                withdrawRequestedAt: new Date(),
                referrerUPI: userData.upiId
            });

            alert("Withdrawal requested! Admin will process within 24 hours.");
        } catch (error) {
            console.error("Error requesting withdrawal:", error);
            alert("Failed to request withdrawal");
        }
    };

    if (userLoading) {
        return (
            <div style={{ padding: "20px", textAlign: "center" }}>
                <ClipLoader size={30} color="#28a745" />
                <p>Loading your account...</p>
            </div>
        );
    }

    return (<>
        <Helmet>
            <title>Exam Preparation - 30 Days Access</title>
            <meta name="description" content="30 days full access to government exam study materials. Flowcharts, MCQs, current affairs." />

            {/* Social Media Sharing */}
            <meta property="og:title" content="Exam Preparation - 30 Days Access" />
            <meta property="og:description" content="Complete study materials for UPSC, SSC, Banking exams." />
            <meta property="og:image" content="/logo.png" />
            <meta property="og:url" content={window.location.href} />
        </Helmet>

        <div style={{ padding: "20px", maxWidth: "1000px", margin: "0 auto" }}>
            <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
                {/* Hero Header */}
                <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                    <h1 style={{
                        color: '#1a5f23',
                        fontSize: 'clamp(28px, 5vw, 40px)',
                        marginBottom: '15px',
                        background: 'linear-gradient(90deg, #1a5f23, #28a745)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        fontWeight: '800'
                    }}>
                        Unlock Complete Exam Mastery
                    </h1>
                    <p style={{
                        color: '#555',
                        fontSize: 'clamp(16px, 2.5vw, 20px)',
                        maxWidth: '800px',
                        margin: '0 auto',
                        lineHeight: '1.5'
                    }}>
                        One subscription. All subjects. Every competitive exam covered.
                    </p>
                </div>

                {/* Pricing Banner */}
                <div style={{
                    background: 'linear-gradient(135deg, #e8f5e8, #c8e6c9)',
                    borderRadius: '12px',
                    padding: '15px',
                    textAlign: 'center',
                    marginBottom: '30px',
                    border: '2px solid #28a745'
                }}>
                    <p style={{
                        margin: 0,
                        fontSize: 'clamp(18px, 3vw, 22px)',
                        fontWeight: 'bold',
                        color: '#1a5f23'
                    }}>
                        🎯 Get <span style={{ color: '#d32f2f' }}>ALL Premium Features</span> at One Price!
                    </p>
                </div>

                {/* Subscription Plans - Mobile Optimized Grid */}
                <div style={{
                    display: 'grid',
                    // gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
                    gap: '25px',
                    marginBottom: '40px'
                }}>
                    {subscriptionPlans.map((plan) => (
                        <div key={plan.id} style={{
                            border: '3px solid #28a745',
                            borderRadius: '15px',
                            padding: 'clamp(15px, 3vw, 25px)',
                            backgroundColor: '#ffffff',
                            boxShadow: '0 8px 25px rgba(40, 167, 69, 0.15)',
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            position: 'relative',
                            overflow: 'hidden'
                        }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        >
                            {/* Price Badge */}
                            <div style={{
                                position: 'absolute',
                                top: '0',
                                right: '0',
                                background: 'linear-gradient(45deg, #28a745, #2e7d32)',
                                color: 'white',
                                padding: '8px 20px',
                                borderBottomLeftRadius: '15px',
                                fontWeight: 'bold',
                                fontSize: 'clamp(16px, 2vw, 20px)',
                                boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
                            }}>
                                ₹{plan.price}
                            </div>

                            {/* Plan Header */}
                            <div style={{ marginBottom: '20px' }}>
                                <h3 style={{
                                    color: '#1a5f23',
                                    marginBottom: '10px',
                                    fontSize: 'clamp(20px, 3vw, 24px)',
                                    fontWeight: '700',
                                    paddingRight: '80px'
                                }}>
                                    {plan.name} Premium Plan
                                </h3>
                                <p style={{
                                    color: '#666',
                                    fontSize: '14px',
                                    marginBottom: '5px'
                                }}>
                                    Complete access to all paid features:
                                </p>
                            </div>

                            {/* Features List */}
                            <div style={{
                                flex: '1',
                                marginBottom: '25px'
                            }}>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                    gap: '12px'
                                }}>
                                    {[
                                        { icon: '📚', text: 'All Subjects: History, Geography, Polity, Biology' },
                                        { icon: '📊', text: 'Download Flowcharts & Revision Notes PDF' },
                                        { icon: '🔤', text: '1000+ Vocabulary & Idioms Database' },
                                        { icon: '🧠', text: '10,000+ MCQs with Detailed Solutions' },
                                        { icon: '🏛️', text: 'Useful for UPSC, SSC, Banking, Railways' },
                                        { icon: '📱', text: 'Mobile & Desktop Access' },
                                    ].map((feature, index) => (
                                        <div key={index} style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '10px'
                                        }}>
                                            <span style={{
                                                color: '#28a745',
                                                fontSize: '18px',
                                                flexShrink: 0
                                            }}>{feature.icon}</span>
                                            <span style={{
                                                fontSize: 'clamp(13px, 1.5vw, 14px)',
                                                lineHeight: '1.4',
                                                color: '#333'
                                            }}>{feature.text}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Exam Suitability */}
                            <div style={{
                                backgroundColor: '#f0f9f0',
                                padding: '15px',
                                borderRadius: '10px',
                                marginBottom: '20px',
                                border: '1px dashed #28a745'
                            }}>
                                <p style={{
                                    fontSize: '14px',
                                    color: '#2e7d32',
                                    margin: 0,
                                    fontWeight: '600',
                                    textAlign: 'center'
                                }}>
                                    📈 Perfect For: UPSC • SSC • Banking • Railway • State PSCs • And 50+ More Exams!
                                </p>
                            </div>

                            {/* Subscribe Button */}
                            <button
                                onClick={() => handleSubscribe(plan)}
                                disabled={loading}
                                style={{
                                    width: '100%',
                                    padding: 'clamp(14px, 3vw, 16px)',
                                    background: loading
                                        ? '#ccc'
                                        : 'linear-gradient(135deg, #28a745, #2e7d32)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    fontSize: 'clamp(16px, 2vw, 18px)',
                                    fontWeight: 'bold',
                                    transition: 'all 0.3s ease',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}
                                onMouseOver={(e) => !loading && (e.currentTarget.style.background = 'linear-gradient(135deg, #2e7d32, #1b5e20)')}
                                onMouseOut={(e) => !loading && (e.currentTarget.style.background = 'linear-gradient(135deg, #28a745, #2e7d32)')}
                            >
                                {loading ? (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                        <ClipLoader size={20} color="#ffffff" />
                                        <span>Processing...</span>
                                    </div>
                                ) : (
                                    <>
                                        <span style={{ marginRight: '10px' }}>🚀</span>
                                        CLICK TO SUBSCRIBE
                                        <span style={{
                                            position: 'absolute',
                                            right: '20px',
                                            fontSize: '14px',
                                            opacity: '0.9'
                                        }}>
                                            {/* ₹{plan.price}/mo */}
                                        </span>
                                    </>
                                )}
                            </button>

                            {/* Security & Benefits */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: 'clamp(10px, 2vw, 20px)',
                                marginTop: '15px',
                                flexWrap: 'wrap'
                            }}>
                                <span style={{
                                    fontSize: '12px',
                                    color: '#666',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px'
                                }}>
                                    🔒 Secure Payment
                                </span>
                                <span style={{
                                    fontSize: '12px',
                                    color: '#666',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px'
                                }}>
                                    ⚡ Instant Access
                                </span>
                                <span style={{
                                    fontSize: '12px',
                                    color: '#666',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px'
                                }}>
                                    📞 7-Day Support
                                </span>
                            </div>
                        </div>
                    ))}
                </div>

                {/* NEW: Phone Number Section */}
                {auth.currentUser && <div style={{ marginBottom: '15px', padding: '15px', backgroundColor: '#e7f3ff', borderRadius: '8px', border: '1px solid #b3d9ff' }}>
                    <h4 style={{ marginBottom: '10px', color: '#0066cc' }}>📞 Contact Information</h4>

                    {!userData?.phoneNumber ? (
                        <div>
                            <p style={{ marginBottom: '10px', fontSize: '14px' }}>
                                <strong>Set your phone number for transaction verification and support:</strong>
                            </p>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                                <input
                                    type="tel"
                                    placeholder="Enter your phone number."
                                    value={tempPhoneNumber}
                                    onChange={(e) => setTempPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
                                    style={{
                                        padding: '8px',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        fontSize: "14px"
                                        // width: '200px'
                                    }}
                                    maxLength="10"
                                />
                                <button
                                    onClick={savePhoneNumber}
                                    style={{
                                        padding: '8px 16px',
                                        backgroundColor: '#0066cc',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '5px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Save Phone Number
                                </button>
                            </div>
                            <p style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
                                🔒 We'll use this only for transaction verification and customer support
                            </p>
                        </div>
                    ) : (
                        <div>
                            <p style={{ marginBottom: '8px' }}>
                                <strong>Your Phone Number:</strong> +91 {userData.phoneNumber}
                            </p>
                            <button
                                onClick={() => {
                                    setShowPhoneForm(!showPhoneForm);
                                    setTempPhoneNumber(userData.phoneNumber || '');
                                }}
                                style={{
                                    padding: '5px 10px',
                                    backgroundColor: 'transparent',
                                    color: '#0066cc',
                                    border: '1px solid #0066cc',
                                    borderRadius: '3px',
                                    cursor: 'pointer',
                                    fontSize: '12px'
                                }}
                            >
                                Change Phone Number
                            </button>

                            {showPhoneForm && (
                                <div style={{ marginTop: '10px', display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                                    <input
                                        type="tel"
                                        placeholder="New phone number"
                                        value={tempPhoneNumber}
                                        onChange={(e) => setTempPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
                                        style={{
                                            padding: '6px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            width: '200px'
                                        }}
                                        maxLength="10"
                                    />
                                    <button
                                        onClick={savePhoneNumber}
                                        style={{
                                            padding: '6px 12px',
                                            backgroundColor: '#0066cc',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '3px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Update
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>}

                {/* Final Call to Action */}
                {/* <div style={{
                    textAlign: 'center',
                    padding: '20px',
                    backgroundColor: '#f8fff8',
                    borderRadius: '12px',
                    border: '2px dashed #28a745'
                }}>
                    <p style={{
                        fontSize: 'clamp(16px, 2vw, 18px)',
                        color: '#1a5f23',
                        fontWeight: '600',
                        marginBottom: '10px'
                    }}>
                        💡 Everything you need for exam success. No hidden costs, no extra charges.
                    </p>
                    <p style={{
                        fontSize: '14px',
                        color: '#666',
                        margin: 0
                    }}>
                        Join <strong>10,000+</strong> successful students who aced their exams with our complete package!
                    </p>
                </div> */}
            </div>

            {!auth.currentUser && (
                <div style={{
                    textAlign: 'center',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    padding: '25px',
                    borderRadius: '12px',
                    color: 'white',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                    marginBottom: "15px"
                }}>
                    <div style={{
                        fontSize: '42px',
                        marginBottom: '10px'
                    }}>
                        💰
                    </div>
                    <h3 style={{
                        marginBottom: '8px',
                        fontSize: '20px',
                        fontWeight: '600'
                    }}>
                        Earn ₹20 Per Referral
                    </h3>
                    <p style={{
                        marginBottom: '20px',
                        opacity: '0.9',
                        fontSize: '15px'
                    }}>
                        Get paid when your friends subscribe
                    </p>
                    <div style={{
                        display: 'flex',
                        gap: '12px',
                        flexWrap: 'wrap',
                        justifyContent: 'center'
                    }}>
                        <button
                            onClick={() => navigate('/login')}
                            style={{
                                padding: '12px 24px',
                                backgroundColor: 'white',
                                color: '#667eea',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '15px',
                                fontWeight: '600',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                            }}
                            onMouseOver={(e) => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                            }}
                        >
                            🔓 Login
                        </button>
                        <button
                            onClick={() => navigate('/signup')}
                            style={{
                                padding: '12px 24px',
                                backgroundColor: '#FFD700',
                                color: '#000',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '15px',
                                fontWeight: '600',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                            }}
                            onMouseOver={(e) => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                            }}
                        >
                            🚀 Sign Up Free
                        </button>
                    </div>
                    <p style={{
                        marginTop: '15px',
                        fontSize: '13px',
                        opacity: '0.8',
                        fontStyle: 'italic'
                    }}>
                        Instant referral code after registration
                    </p>
                </div>
            )}


            {/* User's Referral Code Section */}
            {auth.currentUser && (
                <div style={{
                    backgroundColor: '#f8f9fa',
                    padding: '20px',
                    borderRadius: '10px',
                    marginBottom: '30px',
                    border: '1px solid #dee2e6'
                }}>
                    <h3 style={{ marginBottom: '15px' }}>🎁 Your Referral Code</h3>

                    {!userData?.referralCode ? (
                        <div>
                            <p>Generate your unique referral code to earn ₹20 for each friend who subscribes!</p>
                            <button
                                onClick={generateReferralCode}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                }}
                            >
                                Generate My Referral Code
                            </button>

                        </div>
                    ) : (
                        <div>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap' }}>
                                <strong>Your Code:</strong>
                                <code style={{
                                    backgroundColor: '#e9ecef',
                                    padding: '8px 15px',
                                    borderRadius: '5px',
                                    fontWeight: 'bold',
                                    fontSize: '18px',
                                    fontFamily: 'monospace',
                                    border: '2px solid #28a745'
                                }}>
                                    {userData.referralCode}
                                </code>
                                <button
                                    onClick={copyReferralLink}
                                    style={{
                                        padding: '8px 16px',
                                        backgroundColor: '#28a745',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '5px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Copy Referral Link
                                </button>
                            </div>

                            {/* NEW: Phone Number Section */}
                            {/* <div style={{ marginBottom: '15px', padding: '15px', backgroundColor: '#e7f3ff', borderRadius: '8px', border: '1px solid #b3d9ff' }}>
                                <h4 style={{ marginBottom: '10px', color: '#0066cc' }}>📞 Contact Information</h4>

                                {!userData?.phoneNumber ? (
                                    <div>
                                        <p style={{ marginBottom: '10px', fontSize: '14px' }}>
                                            <strong>Set your phone number for transaction verification and support:</strong>
                                        </p>
                                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                                            <input
                                                type="tel"
                                                placeholder="Enter your 10-digit phone number"
                                                value={tempPhoneNumber}
                                                onChange={(e) => setTempPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
                                                style={{
                                                    padding: '8px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    width: '250px'
                                                }}
                                                maxLength="10"
                                            />
                                            <button
                                                onClick={savePhoneNumber}
                                                style={{
                                                    padding: '8px 16px',
                                                    backgroundColor: '#0066cc',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '5px',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                Save Phone Number
                                            </button>
                                        </div>
                                        <p style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
                                            🔒 We'll use this only for transaction verification and customer support
                                        </p>
                                    </div>
                                ) : (
                                    <div>
                                        <p style={{ marginBottom: '8px' }}>
                                            <strong>Your Phone Number:</strong> +91 {userData.phoneNumber}
                                        </p>
                                        <button
                                            onClick={() => {
                                                setShowPhoneForm(!showPhoneForm);
                                                setTempPhoneNumber(userData.phoneNumber || '');
                                            }}
                                            style={{
                                                padding: '5px 10px',
                                                backgroundColor: 'transparent',
                                                color: '#0066cc',
                                                border: '1px solid #0066cc',
                                                borderRadius: '3px',
                                                cursor: 'pointer',
                                                fontSize: '12px'
                                            }}
                                        >
                                            Change Phone Number
                                        </button>

                                        {showPhoneForm && (
                                            <div style={{ marginTop: '10px', display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                                                <input
                                                    type="tel"
                                                    placeholder="New phone number"
                                                    value={tempPhoneNumber}
                                                    onChange={(e) => setTempPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
                                                    style={{
                                                        padding: '6px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '4px',
                                                        width: '200px'
                                                    }}
                                                    maxLength="10"
                                                />
                                                <button
                                                    onClick={savePhoneNumber}
                                                    style={{
                                                        padding: '6px 12px',
                                                        backgroundColor: '#0066cc',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '3px',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    Update
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div> */}

                            {/* UPI ID Section */}
                            {!userData.upiId ? (
                                <div style={{ marginTop: '15px' }}>
                                    <p style={{ marginBottom: '10px' }}>
                                        <strong>Set UPI ID to receive payments:</strong>
                                    </p>
                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                                        <input
                                            type="text"
                                            placeholder="Enter your UPI ID (e.g., yourname@upi)"
                                            value={tempUpiId}
                                            onChange={(e) => setTempUpiId(e.target.value)}
                                            style={{
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                width: '250px'
                                            }}
                                        />
                                        <button
                                            onClick={saveUpiId}
                                            style={{
                                                padding: '8px 16px',
                                                backgroundColor: '#ffc107',
                                                color: 'black',
                                                border: 'none',
                                                borderRadius: '5px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Save UPI ID
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div style={{ marginTop: '10px' }}>
                                    <p><strong>Your UPI ID:</strong> {userData.upiId}</p>
                                    <button
                                        onClick={() => {
                                            setShowUpiForm(!showUpiForm);
                                            setTempUpiId(userData.upiId || '');
                                        }}
                                        style={{
                                            padding: '5px 10px',
                                            backgroundColor: 'transparent',
                                            color: '#007bff',
                                            border: '1px solid #007bff',
                                            borderRadius: '3px',
                                            cursor: 'pointer',
                                            fontSize: '12px'
                                        }}
                                    >
                                        Change UPI ID
                                    </button>

                                    {showUpiForm && (
                                        <div style={{ marginTop: '10px', display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                                            <input
                                                type="text"
                                                placeholder="New UPI ID"
                                                value={tempUpiId}
                                                onChange={(e) => setTempUpiId(e.target.value)}
                                                style={{
                                                    padding: '6px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    width: '200px'
                                                }}
                                            />
                                            <button
                                                onClick={saveUpiId}
                                                style={{
                                                    padding: '6px 12px',
                                                    backgroundColor: '#ffc107',
                                                    color: 'black',
                                                    border: 'none',
                                                    borderRadius: '3px',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                Update
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}

                            <p style={{ marginTop: '15px', fontSize: '14px', color: '#6c757d' }}>
                                💡 Share your referral link with friends. When they subscribe using your link, you earn ₹20!
                            </p>
                        </div>
                    )}
                </div>
            )}

            {/* Friend's Referral Input */}
            <div style={{ marginBottom: '30px', textAlign: 'center' }}>
                <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold', fontSize: '18px' }}>
                    Using a friend's referral code? Enter it here:
                </label>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                    <input
                        type="text"
                        placeholder="Enter friend's referral code"
                        value={referralCode}
                        onChange={(e) => setReferralCode(e.target.value.toUpperCase())}
                        style={{
                            padding: '12px',
                            border: '2px solid #007bff',
                            borderRadius: '6px',
                            width: '250px',
                            textAlign: 'center',
                            fontSize: '16px'
                        }}
                    />
                    <button
                        onClick={handleReferralCodeSubmit}
                        style={{
                            padding: '12px 20px',
                            backgroundColor: '#28a745',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '16px'
                        }}
                    >
                        Apply Code
                    </button>
                </div>
                {referralCode && (
                    <p style={{ marginTop: '10px', color: '#28a745' }}>
                        ✅ Referral Code is Applied Successfully!
                    </p>
                )}
            </div>



            {/* ✅ UPDATED: User's Referrals Table using the new structure */}
            {userReferrals.length > 0 && (
                <div style={{ marginTop: '40px' }}>
                    <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Your Referral Earnings</h2>
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: 'white' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f8f9fa' }}>
                                    <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Action</th>
                                    <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Friend</th>
                                    <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Date</th>
                                    <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Commission</th>
                                    <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userReferrals.map((referral) => (
                                    <tr key={referral.id}>
                                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                                            {!referral.withdrawRequested && !referral.withdrawPaid && (
                                                <button
                                                    onClick={() => requestWithdraw(referral.id)}
                                                    style={{
                                                        padding: '6px 12px',
                                                        backgroundColor: '#007bff',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    Request Withdraw
                                                </button>
                                            )}
                                            {referral.withdrawRequested && !referral.withdrawPaid && (
                                                <span style={{ color: '#ffc107', fontWeight: 'bold' }}>⏳ Pending Payment</span>
                                            )}
                                            {referral.withdrawPaid && (
                                                <span style={{ color: '#28a745', fontWeight: 'bold' }}>✅ Paid</span>
                                            )}
                                        </td>
                                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                                            <div>
                                                <strong>{referral.friendName}</strong>
                                                <br />
                                                <small>{referral.friendEmail}</small>
                                            </div>
                                        </td>
                                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                                            {new Date(referral.createdAt?.toDate?.() || referral.createdAt).toLocaleDateString()}
                                        </td>
                                        <td style={{ padding: '12px', border: '1px solid #ddd', fontWeight: 'bold', color: 'green' }}>
                                            ₹{referral.commission}
                                        </td>
                                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                                            <span style={{
                                                padding: '4px 8px',
                                                borderRadius: '12px',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                backgroundColor:
                                                    referral.withdrawPaid ? '#d4edda' :
                                                        referral.status === 'completed' ? '#e8f5e8' :
                                                            referral.withdrawRequested ? '#fff3cd' : '#f8d7da',
                                                color:
                                                    referral.withdrawPaid ? '#155724' :
                                                        referral.status === 'completed' ? '#2e7d32' :
                                                            referral.withdrawRequested ? '#856404' : '#721c24'
                                            }}>
                                                {referral.withdrawPaid ? 'PAID' :
                                                    referral.status === 'completed' ? 'COMPLETED' :
                                                        referral.withdrawRequested ? 'REQUESTED' : 'PENDING'}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            <div style={{ marginTop: "30px", textAlign: "center" }}>
                <button
                    onClick={() => navigate(-1)}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#6c757d",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer"
                    }}
                >
                    ← Go Back
                </button>
            </div>
        </div>
    </>
    );
};

export default SubscriptionPage;